module.exports = __webpack_public_path__ + "fonts/Roboto-500-math44.1097956.woff2";